/*
 * bd-page.js — click-to-enlarge for the Behind the Design exploded diagram.
 *
 * The hero image is the most important asset on the page and the page body is
 * plain HTML with no interaction hooks, so the trigger is built here at runtime
 * rather than baked into the page record. No JS, no lightbox — the image still
 * renders full width, which is the pre-existing behaviour.
 *
 * Uses <dialog>.showModal(), which gives focus trapping, inertness of the page
 * behind, and Esc-to-close natively.
 */
(function () {
  'use strict';

  function init() {
    var figure = document.querySelector('.bd-hero figure');
    if (!figure) return;

    var img = figure.querySelector('img');
    if (!img || figure.querySelector('.bd-zoom-trigger')) return;

    // <dialog> is required; without it, leave the plain image alone.
    if (typeof HTMLDialogElement === 'undefined' || !document.createElement('dialog').showModal) {
      return;
    }

    // Wrap the image in a real button so it is keyboard reachable and announced.
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'bd-zoom-trigger';
    trigger.setAttribute('aria-label', 'Enlarge diagram' + (img.alt ? ': ' + img.alt : ''));
    img.parentNode.insertBefore(trigger, img);
    trigger.appendChild(img);

    var hint = document.createElement('figcaption');
    hint.className = 'bd-zoom-hint';
    hint.textContent = 'Click to enlarge';
    figure.appendChild(hint);

    var dialog = document.createElement('dialog');
    dialog.className = 'bd-lightbox';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'bd-lightbox__close';
    close.setAttribute('aria-label', 'Close enlarged diagram');
    close.textContent = '×';

    var large = document.createElement('img');
    large.src = img.currentSrc || img.src;
    large.alt = img.alt || '';

    dialog.appendChild(close);
    dialog.appendChild(large);
    document.body.appendChild(dialog);

    trigger.addEventListener('click', function () {
      dialog.showModal();
    });

    close.addEventListener('click', function () {
      dialog.close();
    });

    // Click outside the image closes. The dialog fills the backdrop area, so
    // compare against the image's own box rather than relying on event.target.
    dialog.addEventListener('click', function (event) {
      var box = large.getBoundingClientRect();
      var outside =
        event.clientX < box.left ||
        event.clientX > box.right ||
        event.clientY < box.top ||
        event.clientY > box.bottom;
      if (outside && event.target !== close) dialog.close();
    });

    // Return focus to the trigger when the dialog closes by any route.
    dialog.addEventListener('close', function () {
      trigger.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
